"use strict";
exports.__esModule = true;
exports.AllTransactionBaseTypes = exports.TransactionBaseType = void 0;
var TransactionBaseType;
(function (TransactionBaseType) {
    TransactionBaseType["Buy"] = "BUY";
    TransactionBaseType["Sell"] = "SELL";
    TransactionBaseType["Deposit"] = "DEPOSIT";
    TransactionBaseType["Withdrawal"] = "WITHDRAWAL";
    TransactionBaseType["IncomeIn"] = "INCOMEIN";
    TransactionBaseType["IncomeOut"] = "INCOMEOUT";
    TransactionBaseType["TransferIn"] = "TRANSFERIN";
    TransactionBaseType["TransferOut"] = "TRANSFEROUT";
    TransactionBaseType["Fee"] = "FEE";
    TransactionBaseType["FeeReversal"] = "FEEREVERSAL";
})(TransactionBaseType = exports.TransactionBaseType || (exports.TransactionBaseType = {}));
exports.AllTransactionBaseTypes = Object.values(TransactionBaseType);
// REMINDER:  If adding any new BaseTypes that are Dateable, make sure the DateableTransactionType
// class is updated to cover requirements.
